import React, { useEffect, useState } from 'react'
import { Modal, Button, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import Cw8Edit from 'components/cw8/Cw8Edit';
import Cw8List from 'components/cw8/Cw8List';
import { ConfigCard } from 'interfaces/schemaDB';
import { EditButton, useModalForm } from '@refinedev/antd';
import { CrudFilters, useList } from '@refinedev/core';
import Cw8Create from 'components/cw8/Cw8Create';

interface EditSubSeccionProps {
    idSubseccion?: string,
    resourceNameSubSection?: string,
    idSection?: string,
    // isOpenModal: boolean;
    // setOpenModal: (newState: boolean) => void;
}

const configCard: ConfigCard = {
    fieldTitle: "sld_nombre",
    fieldDesc: "sld_nombre",
    fieldImg: ""
}

const configCardSubsecciones: ConfigCard = {
    fieldTitle: "sub_nombre",
    fieldDesc: "sub_descripcion",
    fieldImg: ""
}

interface ISubCategory {
    id: string;
    sub_id_seccion: string;
    sub_nombre: string;
}

const EditSubseccion = ({ idSubseccion, resourceNameSubSection = "subSeccionInfografia", idSection
    // , isOpenModal, setOpenModal
}: EditSubSeccionProps) => {

    const resourceName: string = resourceNameSubSection;
    const {
        // close : closeModal,
        modalProps: editModalProps,
        formProps: editFormProps,
        show: editModalShow,
        // modal: { visible, close, show }
    } = useModalForm({
        // } = useModal({
        action: "edit"
        , resource: resourceName
        , redirect: false

    });


    //BUSCAR LA SECCION DE LA SUBSECCIPN PARA MOSTRA TODAS LAS SUBSECCIONES DE ESA SECCIÓN PARA EDITARLAS
    const { data: subSeccionesData } = useList<ISubCategory>({
        resource: resourceName
        , pagination: {
            pageSize: 100,
        }
        , filters: [
            {
                field: "sub_id",
                operator: "eq",
                value: idSubseccion
            }
        ]
    });

    const [idSeccion, setIdSeccion] = useState<string | null>(null)
    useEffect(() => {
        const subSeccionesAll = subSeccionesData?.data ?? [];
        subSeccionesAll.forEach((subSeccion) => {
            setIdSeccion(subSeccion.sub_id_seccion)
        })

    }, [subSeccionesData])


    const extraContent = (
        <div>
            <Button
                onClick={() => editModalShow(idSubseccion)}
            >Editar Subsección</Button>
        </div>
    );



    //TRAER INFO DE LA SUBSECCION PARA MOSTRAR EL NOMBRE EN EL BOTON
      // GET INFO SUBSECCIONES DE SECCIONES DE LA INFOGRAFIA
//   const { data: subSeccionesData } = useList<ISubCategory>({
//     resource: "subsectionPub"
//     , pagination: {
//       pageSize: 100,
//     }
//     , filters: [
//       {
//         field: "sub_id_seccion",
//         operator: "eq",
//         value: secciones
//       }
//     ]
//   });


    return (
        <>

            <Tabs defaultActiveKey="0"
                tabBarExtraContent={extraContent}
            >
                <TabPane tab={"Slides"} key={10}>
                    {
                        idSubseccion ? (
                            <Cw8List
                                resourceName={"slideInfografia"}
                                filterList={[
                                    {
                                        // field: child.field,
                                        // operator: "eq",
                                        // value: id
                                        field: "sld_id_subseccion",
                                        operator: "eq",
                                        value: idSubseccion
                                    }
                                ]}
                                titleList={"Slides"}
                                showCards={true}
                                createModal={true}
                                editModal={true}
                                configCard={configCard}
                            ></Cw8List>
                        ) : <p>Seleccione una Subsección</p>
                    }
                </TabPane>

                {/* <TabPane tab={"Subsecciones"} key={11}>
                    
                    <Cw8List
                        resourceName = {"subSeccionInfografia"}
                        filterList ={[
                            {
                                // field: child.field,
                                // operator: "eq",
                                // value: id
                                field: "sub_id_seccion",
                                operator: "eq",
                                value: idSeccion
                            }
                        ]}
                        titleList = {"SubSecciones"}
                        showCards = {true}
                        createModal = {true}
                        editModal = {true}                        
                        configCard = {configCardSubsecciones}                    
                    ></Cw8List>  

                </TabPane> */}

                {
                    // idSubseccion && (
                    //     <TabPane tab={'Editar Sub Sección'} key="12">
                    //         <Cw8Edit resourceName = {'subSeccionInfografia'}  id={idSubseccion}></Cw8Edit>
                    //     </TabPane>
                    // )
                }
                {
                    // idSection &&(
                    //     <TabPane tab={'Editar Sección'} key="13">
                    //         <Cw8Edit resourceName = {'seccionInfografia'}  id={idSection}></Cw8Edit>
                    //     </TabPane>
                    // )
                }
                {/* <TabPane tab={"Subseccion"} key="11">
                    <Cw8Edit resourceName = {resourceName} id={idSubseccion} ></Cw8Edit>
                </TabPane> */}

                {/* {
                    childrenForms.filter( item => !item.url ).map( (child, index) =>(
                        <TabPane tab={child.title} key={index+2}>
                            <Cw8List
                                resourceName = {child.resourceName}
                                titleList = {child.title}
                                filterList ={[
                                    {
                                        field: child.field,
                                        operator: "eq",
                                        value: ID
                                    }
                                ]}
                                showCards = {child.showCards?true:false}
                                configCard = {
                                    child.configCard?child.configCard:undefined
                                }
                                createModal = {true}
                                editModal = {true}
                            ></Cw8List>        
                        </TabPane>
                    ))
                } */}
            </Tabs>

            <Modal
                {...editModalProps}
            >
                <Cw8Edit
                    resourceName={resourceName}
                    // filterList = {filterList}
                    editFormProps={editFormProps}
                    modal={true}
                ></Cw8Edit>
            </Modal>





        </>
    )
}

export default EditSubseccion
